<ng-template #announcement>
	<div
		*ngIf="activeUpdate as update"
		class="update-announcement"
	>
		<div class="modal-header">
			<div class="update-announcement-heading">
				<time
					class="update-announcement-date"
					[attr.datetime]="update.publishedAt"
				>
					{{ update.publishedAt | date: 'mediumDate' }}
				</time>
				<h2
					id="flying-update-title"
					class="modal-title"
				>
					{{ update.title }}
				</h2>
			</div>
			<button
				type="button"
				class="btn-close"
				aria-label="Dismiss update announcement"
				(click)="dismiss()"
			></button>
		</div>
		<div
			id="flying-update-content"
			class="modal-body update-announcement-body"
		>
			<img
				*ngIf="update.mascotUrl"
				class="update-announcement-mascot"
				[src]="update.mascotUrl"
				alt="Flying update mascot"
			/>
			<p
				*ngIf="update.summary"
				class="update-announcement-summary"
			>
				{{ update.summary }}
			</p>
			<app-update-content
				[blocks]="update.blocks"
				(appRouteSelected)="dismiss()"
			></app-update-content>
		</div>
		<div class="modal-footer update-announcement-footer">
			<nav
				*ngIf="updates.length > 1"
				class="update-carousel-controls"
				aria-label="Browse updates"
			>
				<button
					type="button"
					class="btn btn-outline-secondary"
					[disabled]="activeIndex === 0"
					(click)="goToUpdate(activeIndex - 1)"
				>
					Previous
				</button>
				<span
					class="update-carousel-position"
					aria-live="polite"
					aria-atomic="true"
				>
					{{ activeIndex + 1 }} of {{ updates.length }}
				</span>
				<button
					type="button"
					class="btn btn-outline-secondary"
					[disabled]="activeIndex === updates.length - 1"
					(click)="goToUpdate(activeIndex + 1)"
				>
					Next
				</button>
			</nav>
			<button
				type="button"
				class="btn btn-primary update-announcement-done"
				ngbAutofocus
				(click)="dismiss()"
			>
				Got it
			</button>
		</div>
	</div>
</ng-template>
